// extracted by mini-css-extract-plugin
export default {"shareLinkButtons":"ShareLinkButtons-module__shareLinkButtons-gnjT"};